var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPremier(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.4997 15.6889C12.0645 15.6889 11.7168 15.672 11.4555 15.6035V11.7084C11.6819 11.6571 12.0993 11.606 12.6909 11.606C14.1692 11.606 15.0739 12.2893 15.0739 13.5705C15.0739 14.9202 14.1 15.6889 12.4997 15.6889Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 4C5.34315 4 4 5.34315 4 7V25C4 26.6569 5.34315 28 7 28H25C26.6569 28 28 26.6569 28 25V7C28 5.34315 26.6569 4 25 4H7ZM12.604 10C11.1601 10 10.0989 10.1022 9.33333 10.2391V21.6H11.4555V17.2607C11.7339 17.3122 12.0993 17.3291 12.4997 17.3291C14.0129 17.3291 15.3524 16.9364 16.2045 16.0991C16.8656 15.484 17.2135 14.5784 17.2135 13.4851C17.2135 12.4089 16.7611 11.5034 16.0653 10.9397C15.3175 10.3247 14.1692 10 12.604 10ZM23.0064 13.0921C22.102 13.0921 21.1105 13.6902 20.6929 14.869H20.623L20.5538 13.2803H18.6926C18.7446 14.032 18.762 14.8347 18.762 15.9623V21.6H20.9017V17.2952L20.9713 16.6458C21.1627 15.7059 21.8584 15.057 22.8846 15.057C23.1456 15.057 23.337 15.091 23.5111 15.1254V13.1434L23.0064 13.0921Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPremier);
export default __webpack_public_path__ + "static/media/premier.c90e49ade42c4119a5efa71431408c86.svg";
export { ForwardRef as ReactComponent };